module.exports = __webpack_public_path__ + "img/my-comment.2fac25e1.png";